import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './MessagesTabLayout.module.css'

export interface MessagesTabLayoutProps {
  children?: ReactNode
  testId?: string
}

/**
 * The MessagesTabLayout
 */
export function MessagesTabLayout({
  children,
  testId,
}: MessagesTabLayoutProps) {
  return (
    <div className={cx(styles.root)} data-test={testId}>
      {children}
    </div>
  )
}
